module.exports = __webpack_public_path__ + "img/fopeaInsultosX7.8137e4e4.jpg";